import { Input } from '@heroui/react';
import { Icon } from '@iconify/react';
import { useState } from 'react';

export const FormFieldSecure = ({ label = '', ...props }) => {
  const [secureTextEntry, setSecureTextEntry] = useState(true);

  return (
    <Input
      label={label}
      name="password"
      endContent={
        <button
          className="focus:outline-none"
          type="button"
          onClick={() => setSecureTextEntry(!secureTextEntry)}
        >
          {secureTextEntry ? (
            <Icon
              icon="mdi:eye"
              className="text-2xl text-default-400 pointer-events-none"
            />
          ) : (
            <Icon
              icon="mdi:eye-off"
              className="text-2xl text-default-400 pointer-events-none"
            />
          )}
        </button>
      }
      type={secureTextEntry ? 'password' : 'text'}
      {...props}
    />
  );
};
